import {cssTheme} from '../theme'
import {css} from '../theme/css'
import {spacing} from '../theme/theme'
import {makeStyles} from '../theme/UNSTABLE_makeStyles'

const classes = {
  root: css`
    min-height: ${spacing(3.5)};
    display: inline-flex;
    align-items: flex-start;
    justify-content: center;
    box-sizing: border-box;
    background-color: ${cssTheme.default.day.backgroundMinor};
    border-radius: ${spacing(1.75)};
    padding: ${spacing(0.75)};
  `,
  icon: css`
    font-size: 16px !important;
  `,
  label: css`
    padding: ${spacing(0, 0.75)};
    align-self: center;
    max-width: 450px;
    overflow: hidden;
  `,
  textWrap: css`
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    display: block;
  `,
}

export type ClassKey = keyof typeof classes

export const useClasses = makeStyles(classes)
